<script setup lang="ts">
const { t } = useI18n()

const LOGO = '/images/logo_hp_dark.svg'

const route = useRoute()
withDefaults(
  defineProps<{
    title?: string
    shouldShowRedirectToLoginLink?: boolean
    subtitle?: string
  }>(),
  {
    title: '',
    shouldShowRedirectToLoginLink: true,
    subtitle: ''
  }
)
</script>

<template>
  <div class="flex min-h-screen w-full items-stretch">
    <div class="relative flex w-full flex-col justify-center px-6 pb-12 pt-28 sm:px-10 lg:w-1/2 lg:px-16">
      <div class="absolute left-0 top-0 p-6">
        <img class="h-8 w-auto" :src="LOGO" alt="Pongo" />
      </div>

      <div class="mx-auto w-full max-w-[400px]">
        <div v-if="title || $slots.title">
          <slot name="title">
            <h1 class="text-3xl font-semibold text-cta">
              {{ title }}
            </h1>
            <p v-if="subtitle" class="mt-2 text-sm text-muted-foreground">
              {{ subtitle }}
            </p>
          </slot>
        </div>

        <div :class="title || $slots.title ? 'mt-8' : ''">
          <slot />
        </div>

        <div v-if="$slots.footer" class="mt-8 border-t pt-6">
          <slot name="footer" />
        </div>

        <p v-if="shouldShowRedirectToLoginLink" class="mt-6 text-center text-xs font-medium">
          {{ t('signup.account.alreadyHaveAnAccount') }}
          <router-link
            :to="{ query: route.query, name: 'Login' }"
            class="mt-1 block font-semibold text-primary hover:text-primary/80 md:mt-0 md:inline"
          >
            {{ t('login.account.form.login') }}
          </router-link>
        </p>
      </div>
    </div>

    <div v-if="$slots.aside" class="hidden lg:sticky lg:top-0 lg:block lg:h-screen lg:w-1/2">
      <slot name="aside" />
    </div>
  </div>
</template>
